module.exports = __webpack_public_path__ + "static/media/snippet_alive_un.35ab7efc.png";